import getConfig from 'next/config';
import {
  WEB_SCHEMA,
  WEBPAGE_SCHEMA_TYPE,
} from '../../../constants/stocks/componentStaticData';
import { Meta } from '../../../layout/Meta';
import { b2cData } from '../../cms/layout/components/header';
import { ClearInNavbar } from '../../Navbar/ClearNavbar';
import { ALL_CITIES, GOLD_CITY, METALS, SILVER_CITY } from '../common/types';
import { capitalized } from '../common/utils';
import { SilverCityHomepage } from '../silver-city-page';
import { StocksLayout } from './stocks-layout';
import { getFullDateWithOrdinals } from '../../Utils/UtilFunctions';

interface GOLD_RATE_PROPS {
  city: string;
  date?: string;
  data: SILVER_CITY | GOLD_CITY;
  cities: ALL_CITIES;
  graphData: number[][];
  top_cta: string;
}
const { publicRuntimeConfig } = getConfig();

const SilverPageLayout = ({
  city,
  data,
  cities,
  graphData,
  top_cta,
}: GOLD_RATE_PROPS): JSX.Element => {
  const capitalizedCityName = capitalized(city);
  const todayDate = getFullDateWithOrdinals(new Date().toDateString());
  const seoDetails: WEBPAGE_SCHEMA_TYPE = {
    title: `Silver Rate in ${capitalizedCityName} Today (${todayDate}), Silver Price in ${capitalizedCityName} - ClearTax`,
    metaDesc: `Today Silver Rate in ${capitalizedCityName} (${todayDate}): Get silver price in ${capitalizedCityName} for 1 gram, 10 gram and 1 kg. Check out last 10 days silver price trend and movement in ${capitalizedCityName} at ClearTax.`,
    url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/${METALS.SILVER}-rate-${city}`,
  };

  return (
    <StocksLayout
      slider={false}
      meta={
        <Meta
          title={seoDetails.title}
          description={seoDetails.metaDesc}
          canonical={seoDetails.url}
        />
      }
    >
      <ClearInNavbar data={b2cData} />

      <SilverCityHomepage
        goldData={data as SILVER_CITY}
        cityData={cities}
        city={{ type: 'major', name: city }}
        graphData={graphData}
        metal={METALS.SILVER}
        top_cta={top_cta}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(WEB_SCHEMA(seoDetails)),
        }}
      ></script>
    </StocksLayout>
  );
};

export default SilverPageLayout;
